import { render } from "./ProductBoxWideSegmentCenter.vue?vue&type=template&id=513cdece&ts=true"
import script from "./ProductBoxWideSegmentCenter.vue?vue&type=script&lang=ts"
export * from "./ProductBoxWideSegmentCenter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__